module.exports = __webpack_public_path__ + "media/information/framed-mosaics-cta-300-42928697.jpeg";